export const MAP_SELECT_DEVICE = 'MAP_SELECT_DEVICE';
export const MAP_UNSELECT_DEVICE = 'MAP_UNSELECT_DEVICE';
export const MAP_CLEAR_SELECTION = 'MAP_CLEAR_SELECTION';
export const MAP_SET_SELECTION_MODE = 'MAP_SET_SELECTION_MODE';
export const MAP_SELECT_DEVICES = 'MAP_SELECT_DEVICES';
export const MAP_UNSELECT_DEVICES = 'MAP_UNSELECT_DEVICES';
export const MAP_SET_TILE_MODE = 'MAP_SET_TILE_MODE';
export const MAP_SET_HOVERED_DEVICES = 'MAP_SET_HOVERED_DEVICES';

export const PROCESSING_SELECTION = 'PROCESSING_SELECTION';

export const setHoveredDevices = (features) => ({
  type: MAP_SET_HOVERED_DEVICES,
  ids: features.map((f) => f.get('id')),
})

export const selectDevice = (device_id) => ({
  type:  MAP_SELECT_DEVICE,
  device_id
});

export const unselectDevice = (device_id) => {
  return {
    type:  MAP_UNSELECT_DEVICE,
    device_id
  }
};

export const clearDeviceSelection = () => ({
  type: MAP_CLEAR_SELECTION
});

export const selectDevices = (device_ids) => ({
  type:  MAP_SELECT_DEVICES,
  device_ids
});

export const unselectDevices = (device_ids) => ({
  type:  MAP_UNSELECT_DEVICES,
  device_ids
});

export const setSelectionMode = (selection_mode) => ({
  type: MAP_SET_SELECTION_MODE,
  selection_mode
});

export const setTileMode = (tile_mode) => ({
  type: MAP_SET_TILE_MODE,
  tile_mode,
})



// WEBPACK FOOTER //
// ./src/actions/map.js